import { createContext, useContext, useMemo } from "react";

import { useEnrichDatadogContext } from "./hooks/useDatadogContext";

import type { FC } from "react";
import type { CLOUD_API } from "@skydio/api_util/src";

interface Props {
  user?: CLOUD_API.APIUser;
  organizationUuid?: string;
  children?: React.ReactNode;
}

interface IDatadogContext {
  hasUser: boolean;
  hasOrgUuid: boolean;
}

const DatadogContext = createContext<IDatadogContext>({
  hasUser: false,
  hasOrgUuid: false,
});

const DatadogContextProvider: FC<Props> = ({ user, organizationUuid, children }) => {
  const { hasUser, hasOrgUuid } = useEnrichDatadogContext({ user, organizationUuid });

  const context = useMemo(
    () => ({
      hasUser,
      hasOrgUuid,
    }),
    [hasUser, hasOrgUuid]
  );

  return <DatadogContext.Provider value={context}>{children}</DatadogContext.Provider>;
};

export default DatadogContextProvider;
export const useDatadogContext = () => useContext(DatadogContext);
